const tasks = {
  state: {
    time: "00:00:00",
    current_time_log_id: null,
    parent_task_data: null
  },

  getters: {
    time: (state) => state.time,
    current_time_log_id: (state) => state.current_time_log_id,
    parent_task_data: (state) => state.parent_task_data
  },

  actions: {

  },
  mutations: {
    setCurrentTimeLogId: (state, payload) => (state.current_time_log_id = payload),
    setTime: (state, payload) => (state.time = payload),
    setParentTaskData: (state, payload) => (state.parent_task_data = payload)
  }
}

export default tasks;
